import { createContext } from 'use-context-selector';
export function createDescendantContext(name) {
    const context = createContext({
        descendants: [],
        getDescendants: () => [],
        getVisibleDescendants: () => [],
        registerDescendant: () => () => void 0,
        activeIndex: -1,
        setActiveIndex: () => void 0,
        getActiveIndex: () => -1,
        selected: [],
        getSelected: () => [],
        setSelected: () => void 0,
        setSelectedIndex: () => void 0,
    });
    context.displayName = name;
    return context;
}
//# sourceMappingURL=DescendantsContext.js.map